module.exports = __webpack_public_path__ + "img/card1.cc1341e0.png";